import { API } from '@aws-amplify/api';
import { SurveyQuestion } from '../../@types/subjectSurvey';

export interface GetSubjectSurveyQuestionsInput {
  studentId: string;
  subject: string;
}

export interface GetSubjectSurveyQuestionsResponse {
  questions: SurveyQuestion[];
}

export async function getSubjectSurveyQuestions(
  input: GetSubjectSurveyQuestionsInput
): Promise<GetSubjectSurveyQuestionsResponse> {
  try {
    const apiName = process.env.NEXT_PUBLIC_ONBOARDING_API_NAME!;
    const path = 'api/subject-survey/questions';
    const myInit = {
      headers: {},
      queryStringParameters: {
        studentId: input.studentId,
        subject: input.subject,
      },
    };

    const response = await API.get(apiName, path, myInit);
    return response;
  } catch (error) {
    console.error('Error getting subject survey questions:', error);
    throw error;
  }
}
